// Attachment List
export const FETCH_ATTACHMENTS_REQUEST = 'FETCH_ATTACHMENTS_REQUEST';
export const FETCH_ATTACHMENTS_SUCCESS = 'FETCH_ATTACHMENTS_SUCCESS';
export const FETCH_ATTACHMENTS_FAILURE = 'FETCH_ATTACHMENTS_FAILURE';

// Create Attachment
export const CREATE_ATTACHMENT_REQUEST = 'CREATE_ATTACHMENT_REQUEST';
export const CREATE_ATTACHMENT_SUCCESS = 'CREATE_ATTACHMENT_SUCCESS';
export const CREATE_ATTACHMENT_FAILURE = 'CREATE_ATTACHMENT_FAILURE';

// Bulk Attach
export const BULK_ATTACH_REQUEST = 'BULK_ATTACH_REQUEST';
export const BULK_ATTACH_SUCCESS = 'BULK_ATTACH_SUCCESS';
export const BULK_ATTACH_FAILURE = 'BULK_ATTACH_FAILURE';

// Detach
export const DETACH_POLICY_REQUEST = 'DETACH_POLICY_REQUEST';
export const DETACH_POLICY_SUCCESS = 'DETACH_POLICY_SUCCESS';
export const DETACH_POLICY_FAILURE = 'DETACH_POLICY_FAILURE';

// Update Attachment
export const UPDATE_ATTACHMENT_REQUEST = 'UPDATE_ATTACHMENT_REQUEST';
export const UPDATE_ATTACHMENT_SUCCESS = 'UPDATE_ATTACHMENT_SUCCESS';
export const UPDATE_ATTACHMENT_FAILURE = 'UPDATE_ATTACHMENT_FAILURE';

// Sync Status
export const FETCH_SYNC_STATUS_REQUEST = 'FETCH_SYNC_STATUS_REQUEST';
export const FETCH_SYNC_STATUS_SUCCESS = 'FETCH_SYNC_STATUS_SUCCESS';
export const FETCH_SYNC_STATUS_FAILURE = 'FETCH_SYNC_STATUS_FAILURE';

export const TRIGGER_SYNC_REQUEST = 'TRIGGER_SYNC_REQUEST';
export const TRIGGER_SYNC_SUCCESS = 'TRIGGER_SYNC_SUCCESS';
export const TRIGGER_SYNC_FAILURE = 'TRIGGER_SYNC_FAILURE';

// Clear errors
export const CLEAR_ATTACHMENT_ERROR = 'CLEAR_ATTACHMENT_ERROR';
